
import React from 'react';
import { CloudLightning, Link } from 'lucide-react';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark-card border-t border-dark-border">
      <div className="container mx-auto py-12 px-6 md:px-8 lg:px-12">
        <div className="flex flex-col items-center justify-center">
          <RouterLink to="/" className="inline-block text-2xl font-bold text-white mb-4 flex items-center">
            <CloudLightning className="mr-2 w-8 h-8" />
            SkyTest.ai
          </RouterLink>
          <p className="text-gray-300 max-w-md text-center mb-6">
            The AI-powered test automation platform for multi-user workflow testing. Write tests in plain English, run across multiple browsers.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-x-8 gap-y-2 mb-8">
          <RouterLink to="/features" className="text-gray-300 hover:text-white transition-colors flex items-center">
            <Link className="mr-1 w-4 h-4" />
            Features
          </RouterLink>
          <RouterLink to="/use-cases" className="text-gray-300 hover:text-white transition-colors flex items-center">
            <Link className="mr-1 w-4 h-4" />
            Use Cases
          </RouterLink>
          <RouterLink to="/compare" className="text-gray-300 hover:text-white transition-colors flex items-center">
            <Link className="mr-1 w-4 h-4" />
            Why SkyTest
          </RouterLink>
          <RouterLink to="/blog" className="text-gray-300 hover:text-white transition-colors flex items-center">
            <Link className="mr-1 w-4 h-4" />
            Blog
          </RouterLink>
          <RouterLink to="/privacy-policy" className="text-gray-300 hover:text-white transition-colors flex items-center">
            <Link className="mr-1 w-4 h-4" />
            Privacy Policy
          </RouterLink>
        </div>

        <div className="mt-8 pt-6 border-t border-dark-border flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © {currentYear} SkyTest.ai. All rights reserved.
          </p>
          <div className="text-gray-400 text-sm">
            Brought to you by <a href="https://oursky.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-brand-light transition-default">Oursky</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
